// extracted by mini-css-extract-plugin
module.exports = {"root":"Dashboard_mobiworkx_root__BYm9s","bannerContainer":"Dashboard_mobiworkx_bannerContainer__1C94u","moreSurveysBanner":"Dashboard_mobiworkx_moreSurveysBanner__PLCb8"};